import moment from 'moment';
import { DEVICE_GROUPS } from '../DeviceMoved/constants';

/** Unique key for a device row — deviceId alone can repeat across families. */
export const deviceKey = (device) => `${device.groupKey}:${device.deviceId}`;

/** Every device of a house (all families, all rooms) with the room it sits in. */
export const collectHouseDevices = (house) => {
  const rooms = Array.isArray(house?.rooms) ? house.rooms : [];

  return rooms
    .flatMap((room) =>
      DEVICE_GROUPS.flatMap((group) =>
        (room?.[group.key] || []).map((device) => {
          const name = typeof device?.name === 'string' ? device.name.trim() : '';
          return {
            deviceId: device?.deviceId,
            name: name || device?.deviceId,
            hasName: name !== '',
            groupKey: group.key,
            roomName: room?.roomName || 'Unassigned',
          };
        })
      )
    )
    .filter((device) => device.deviceId);
};

export const matchesSearch = (device, query) => {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return (
    device.deviceId?.toLowerCase().includes(q) ||
    device.name?.toLowerCase().includes(q) ||
    device.roomName?.toLowerCase().includes(q)
  );
};

/** 'online' | 'offline' | 'unknown' for a row's status entry. */
export const statusOf = (entry) => {
  if (!entry || entry.loading || entry.error) return 'unknown';
  return entry.connected ? 'online' : 'offline';
};

export const formatTime = (ms) => (ms ? moment(ms).format('DD MMM YYYY, hh:mm A') : '');

export const fromNow = (ms) => (ms ? moment(ms).fromNow() : '');

/** `MQTT_KEEP_ALIVE_TIMEOUT` -> `Mqtt keep alive timeout`. */
export const humanizeReason = (reason) => {
  if (!reason || typeof reason !== 'string') return '';
  const text = reason.replace(/_/g, ' ').toLowerCase();
  return text.charAt(0).toUpperCase() + text.slice(1);
};

/** Runs `worker` over `items` with at most `limit` in flight. */
export const runPool = async (items, limit, worker) => {
  let next = 0;
  const lanes = Array.from({ length: Math.min(limit, items.length) }, async () => {
    while (next < items.length) {
      const item = items[next++];
      await worker(item);
    }
  });
  await Promise.all(lanes);
};
